module.exports = __webpack_public_path__ + "img/map.66e70f6.png";